//#region src/preview/util.ts
/**
* The schemes a preview link may use — everything else becomes `about:blank`.
*
* An allowlist, because the blocklist it replaces could be walked around and
* the walk-arounds are not exotic. Browsers strip tabs, newlines and carriage
* returns from a URL before parsing the scheme, so `java\tscript:alert(1)` and
* `java%0ascript:…` navigate exactly as `javascript:` does while matching none
* of the names a blocklist knows. A leading control character does the same.
*
* Turned around, none of that matters: a string is either one of these four
* schemes or it is not a link this panel will follow. `mailto:` and `tel:` are
* here because a contact field is an ordinary thing to preview; `data:` is not,
* even for images — a preview renders an `<img>` from its own value rather than
* navigating to one.
*
* Relative URLs are allowed and deliberately: a preview commonly holds
* `/uploads/x.png`, and a string with no scheme cannot carry one.
*/
var ALLOWED_URL_SCHEMES = /* @__PURE__ */ new Set([
	"http:",
	"https:",
	"mailto:",
	"tel:"
]);
function sanitizeUrl(url) {
	if (!url) return "about:blank";
	const trimmed = url.trim().replace(/[\u0000-\u001F\u007F]/g, "");
	if (!trimmed) return "about:blank";
	if (!/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) return trimmed;
	try {
		const parsed = new URL(trimmed, "https://example.invalid");
		return ALLOWED_URL_SCHEMES.has(parsed.protocol) ? trimmed : "about:blank";
	} catch {
		return "about:blank";
	}
}
function getThumbnailMeasure(size) {
	if (size === "small") return 40;
	else if (size === "medium") return 100;
	else if (size === "large") return 200;
	else throw Error("Thumbnail size not mapped");
}
function getPreviewSizeFrom(size) {
	switch (size) {
		case "xs":
		case "s":
		case "m": return "small";
		case "l": return "medium";
		case "xl": return "large";
		default: throw Error("Missing mapping value in getPreviewSizeFrom: " + size);
	}
}
//#endregion
export { getThumbnailMeasure as n, sanitizeUrl as r, getPreviewSizeFrom as t };

//# sourceMappingURL=util-DB31IoJE.js.map